<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/attachments']"><!--{{view.getEntityBaseName(true)}}-->Documentación general</a></li>
</ul>
<p-card>

  <ng-template pTemplate="header">
    <div class="p-card-title">
      Filtros
      <div class="p-card-title-actions">
        <a label="Limpiar filtros" (click)="clearFilters()"><i class="pi pi-filter-slash"></i> Limpiar filtros</a>
        <a label="Buscar" (click)="search()"> <i class="pi pi-search"></i> Buscar </a>
      </div>
    </div>
</ng-template>
    <div class="p-grid">

      <div class="p-col-4 p-field">
        <label for="attachment_type_id">Tipo de documento</label>
        <p-dropdown name="attachmentType" [options]="attachmentsTypes" optionValue="id" placeholder="Selecciona un tipo"
                    [showClear]="true" appendTo="body" optionLabel="name" [(ngModel)]="genericAttachmentsFilters.attachment_type_id">
        </p-dropdown>
      </div>
      <div class="p-col-4 p-field">
        <label for="name">Nombre</label>
        <input id="name" type="text" pInputText [(ngModel)]="genericAttachmentsFilters.name" />
      </div>
      <div class="p-col-4 p-field">
        <label for="description">Descripción</label>
        <input id="description" type="text" pInputText [(ngModel)]="genericAttachmentsFilters.description" />
      </div>
    </div>
</p-card>
<p-card styleClass="p-mt-4 p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Documentos genéricos
            <div class="p-card-title-actions">
                <a *ngIf="createAttachmentPermission" (click)="editAttachment({ id: 0 })"><fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> Nuevo documento</a>
            </div>
        </div>
    </ng-template>
    <p-table #grid [value]="genericAttachments" 
        [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
        [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true" 
        currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas" [rowsPerPageOptions]="[5,10,25,50]" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="id" width="100">ID</th>
            <th pSortableColumn="attachment_type_id">Tipo de documento</th>
            <th pSortableColumn="filename">Nombre del fichero</th>
            <th pSortableColumn="size">Tamaño del fichero</th>
            <th pSortableColumn="created_at">Fecha de creación</th>
            <th pSortableColumn="created_by">Creado por</th>
            <th width="100"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-attachment>
          <tr (dblclick)="editAttachment(attachment)">
            <td>{{attachment.id}}</td>
            <td>{{attachment.attachmentType?.name}}</td>
            <td>{{attachment.filename}}</td>
            <td>{{(attachment.size/1000).toFixed(0)}} KB</td>
            <td>{{attachment.created_at | date: 'dd/MM/yyyy HH:mm'}}</td>
            <td>{{attachment.createdBy?.name}}</td>
            <td class="grid-actions">
              <a *ngIf="editAttachmentPermission" (click)="downloadAttachment(attachment)"><fa-icon [icon]="['fas', 'download']"></fa-icon></a>
              <a *ngIf="editAttachmentPermission" (click)="editAttachment(attachment)"><fa-icon [icon]="['far', 'edit']"></fa-icon></a>
              <a *ngIf="deleteAttachmentPermission" (click)="deleteAttachment(attachment)" class="color-danger"><fa-icon [icon]="['far', 'trash-alt']"></fa-icon></a>
            </td>
          </tr>
        </ng-template>
    </p-table>
</p-card>
